const InOut = {

    // PAGE HEADER
    "in_out": "In/Out",
    "in_out_book": "In/Out Book",
    "in_out_entries": "In/Out Entries",

    // FIELDS
    "entry_type_title": "Select Entry Type",
    "entry_type_description": "Choose who you are creating an In/Out entry for",

    "scan_title": "Scan QR / Barcode",
    "scan_description": "Point the camera at a QR code or barcode to fetch the entry",
    "enter_code_manually": "Or enter code manually",
    "enter_code_placeholder": "e.g. XG-26-27-A-100",
    "submit_code": "Submit",
    "press_start_to_activate_camera": "Press Start to activate the camera",
    "start_scanning": "Start Scanning",
    "stop_scanning": "Stop Scanning",
    "reset": "Reset",
    "scanned_result": "Scanned Result",
    "rescan": "Rescan",
    "check_in": "Check In",
    "service_provider": "Service Provider",
    "visitor": "Visitor",
    "delivery_partner_type": "Delivery",
    "resident_type": "Resident",
    "units": "Units",
    "vehicle": "Vehicle",
    "approved_by": "Approved By",
    "visit_schedule": "Visit Schedule",
    "validity": "Validity",
    "valid_till": "Valid till",
    "expired": "Expired",
    "frequent_visitor": "Frequent",
    "non_frequent_visitor": "Non-Frequent",
    "hireable": "Hireable",
    "non_hireable": "Non-Hireable",
    "police_verified": "Police Verified",
    "police_not_verified": "Not Verified",

    "premise": "Premise",
    "gate": "Gate",
    "gate_direction_in": "In",
    "gate_direction_out": "Out",
    "allowed_all": "All",
    "residents_allowed": "Residents",
    "staff_allowed": "Staff",
    "vendor_allowed": "Vendor",
    "role": "Role",
    "name": "Name",
    "delivery_person_name": "Delivery Person Name",
    "visitor_name": "Visitor Name",
    "delivery_partner": "Delivery Partner",
    "resident": "Resident",
    "staff": "Staff",
    "mobile_number": "Mobile Number",
    "type": "Type",
    "sub_type": "Sub Type",
    "unit": "Unit",
    "purpose": "Purpose",
    "vehicle_number": "Vehicle Number",
    "days": "Days",
    "hours": "Hours",
    "photo_capture": "Photo Capture",
    "id_proof": "ID Proof",
    "parcel_photo": "Parcel Photo",
    "search": "Search",
    "date": "Date",
    "status": "Status",

    // STATUS OPTIONS
    "status_in": "In",
    "status_out": "Out",
    "status_pending": "Pending",
    "status_reject": "Reject",

    // BUTTONS
    "open_camera": "Open Camera",
    "capture_image": "Capture Image",
    "close_camera": "Close Camera",
    "remove": "Remove",
    "in_button": "IN",
    "out_button": "OUT",
    "resend_request": "Resend Request",
    "confirm_resend_title": "Resend Request",
    "confirm_resend_text": "Are you sure you want to resend this request?",

    // TOAST
    "success_visitor_entries": "Under approval… awaiting confirmation",
    "success_entries": "Entry recorded successfully",
    "success_out_entry": "Exit recorded successfully",
    "success_resend_request": "Request resent successfully",
    "success_scan_entry": "Code Scanned Successfully",

    // TABLE HEADERS
    "table_premise": "PREMISE",
    "table_name": "NAME",
    "table_mobile": "MOBILE",
    "table_type": "TYPE",
    "table_sub_type": "SUB TYPE",
    "table_delivery_partner": "DELIVERY PARTNER",
    "table_unit": "UNIT",
    "table_status": "STATUS",
    "table_vehicle": "VEHICLE",
    "table_in_time": "IN TIME",
    "table_out_time": "OUT TIME",
    "table_entry_type": "ENTRY TYPE",


    // ERROR
    "error_premise": "Select Premise",
    "error_gate": "Select Gate",
    "error_gate_nf": "Gate Not Found",
    "error_role": "Select Role",
    "error_delivery_person_name": "Enter Delivery Person Name",
    "error_visitor_name": "Enter Visitor Name",
    "error_delivery_partner": "Select Delivery Partner",
    "error_resident": "Select Resident",
    "error_mobile_number": "Enter Mobile Number",
    "error_invalid_mobile": "Invalid Mobile Number",
    "error_type": "Select Type",
    "error_sub_type": "Select Sub Type",
    "error_unit": "Select Unit",
    "error_purpose": "Enter Purpose",
    "error_vehicle_number": "Enter Vehicle Number",
    "error_invalid_days": "Enter Valid Days",
    "error_invalid_hours": "Enter Valid Hours",
    "error_photo_capture": "Upload Photo Capture",

}

export default InOut;